import React from 'react';
import IconContainer from '../IconContainer';

const svg = (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 0C5.88293 0 0.5 5.38293 0.5 12C0.5 18.6171 5.88293 24 12.5 24C19.1171 24 24.5 18.6171 24.5 12C24.5 5.38293 19.1171 0 12.5 0ZM18.582 9.45703L12.082 15.9569C11.887 16.1519 11.631 16.2501 11.375 16.2501C11.119 16.2501 10.863 16.1519 10.668 15.9569L7.41809 12.707C7.02698 12.316 7.02698 11.684 7.41809 11.293C7.80902 10.9019 8.44092 10.9019 8.83203 11.293L11.375 13.836L17.1681 8.04309C17.559 7.65198 18.1909 7.65198 18.582 8.04309C18.973 8.43402 18.973 9.06592 18.582 9.45703Z" fill="currentColor"/>
  </svg>
);

export default IconContainer(svg);
